import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { map } from "lodash";

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { setSelectedHub } from 'slices/auth/reducer';
import { Hub } from 'types/user';


const HubDropdownFullWidth = () => {

    const dispatch: AppDispatch = useDispatch();

    const hubs = useSelector((state: RootState) => state.auth.user?.hubs);
    const selectedHub = useSelector((state: RootState) => state.auth.selectedHub);

    const changeHub = (hub: Hub) => {
        if (hub.uuid === selectedHub?.uuid) return;
        dispatch(setSelectedHub(hub));
        window.location.href = '/';
    };

    const [isHubDropdown, setIsHubDropdown] = useState(false);
    const toggleHubDropdown = () => {
        setIsHubDropdown(!isHubDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={(isHubDropdown && hubs?.length && hubs.length > 1) ? true : false} size='sm' onClick={e => e.stopPropagation()} toggle={toggleHubDropdown} direction='down' className="ms-1 topbar-head-dropdown w-100">
                <DropdownToggle className="btn d-flex align-items-center justify-content-between btn-sm w-100 p-0" tag="button">
                    <div className='hub-dropdown-full-width px-2 gap-2'>
                        <i className='bx bx-buildings fs-5 ' />
                        <span className='w-100 text-start text-truncate d-flex align-items-center h-100'>{selectedHub?.name}</span>
                        <span>
                            {
                                hubs?.length && hubs?.length > 0 &&
                                <i className='fs-4 text-primary bx bx-refresh' ></i>
                            }
                        </span>
                    </div>

                </DropdownToggle>

                <DropdownMenu className="notify-item language py-2">
                    {map(hubs, hub => (
                        <DropdownItem
                            key={hub.uuid}
                            onClick={() => changeHub(hub)}
                            className={`notify-item ${selectedHub?.uuid === hub.uuid ? "active" : "none"
                                }`}
                        >
                            <span className="align-middle">
                                {hub.name}
                            </span>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default HubDropdownFullWidth;